import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { BASE_URL } from "./Constants";

// Disable browser's automatic history scroll restoration to prevent jumpy / mid-page glitch
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Setup dynamic preconnect and dns-prefetch for cross-origin API domain if BASE_URL is configured
if (typeof document !== "undefined" && BASE_URL) {
  try {
    if (BASE_URL.startsWith("http://") || BASE_URL.startsWith("https://")) {
      const apiUrl = new URL(BASE_URL);
      if (typeof window !== "undefined" && apiUrl.origin !== window.location.origin) {
        const preconnectLink = document.createElement("link");
        preconnectLink.rel = "preconnect";
        preconnectLink.href = apiUrl.origin;
        preconnectLink.crossOrigin = "anonymous";
        document.head.appendChild(preconnectLink);

        const dnsPrefetchLink = document.createElement("link");
        dnsPrefetchLink.rel = "dns-prefetch";
        dnsPrefetchLink.href = apiUrl.origin;
        document.head.appendChild(dnsPrefetchLink);
      }
    }
  } catch (e) {
    // Ignore URL parse errors
  }
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
